import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSettings = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	stroke: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4"
	})
});
export default SvgSettings;
